import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useTranslation } from 'react-i18next'
import { EditWebinarForm } from '@/features/Webinar/EditWebinarForm/ui/EditWbinarForm'

type EditWebinarModalProps = {
  dialogProps: AlertDialogProps
  currentWebinarId: number
  onCloseModal: () => void
}

export const EditWebinarModal: FC<EditWebinarModalProps> = props => {
  const { dialogProps, currentWebinarId, onCloseModal } = props
  const { t } = useTranslation(['webinar'])

  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('webinar:edit_webinar_modal_title')}</DialogTitle>
          <EditWebinarForm currentWebinarId={currentWebinarId} onCloseModal={onCloseModal} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
